import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getCounTimesroll = async (idGacha) => {
  try {
    const res = await axiosInstance.get(API_ROUTES.CountTimeRoll.replace(':id', idGacha))
    return res.data
  } catch (error) {
    console.error('Error fetching count times roll:', error)
    throw error
  }
}

export default getCounTimesroll
